import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { VisitorInfoFieldType } from 'shared/models/visitor-info/visitor-info-field';

@Component({
  selector: 'app-visitor-info-field-block',
  templateUrl: './visitor-info-field-block.component.html',
  encapsulation: ViewEncapsulation.None
})

export class VisitorInfoFieldBlockComponent implements OnChanges {
  @Input()
  visitorInfoFieldBlock;

  @Input()
  title: string;

  @Input()
  isNotAvailableDataHidden: boolean;

  @Input()
  isBlockOpen: boolean;

  @Output()
  blockStateToggled: EventEmitter<boolean> = new EventEmitter();

  public isVisitorInfoFieldBlockVisible: boolean;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.visitorInfoFieldBlock) {
      let hasAtLeastOneVisibleField;
      if (changes.visitorInfoFieldBlock.currentValue) {
        hasAtLeastOneVisibleField = Object.keys(changes.visitorInfoFieldBlock.currentValue).find((key) => {
          const infoFieldValue = changes.visitorInfoFieldBlock.currentValue[key].value;
          return infoFieldValue !== null && infoFieldValue !== '' && infoFieldValue !== undefined;
        });
        this.isVisitorInfoFieldBlockVisible = !!hasAtLeastOneVisibleField;
        this._handleCustomFields();
      }
    }
  }

  public trackByObjectKey(index, key): string {
    return key;
  }

  public getVisitorInfoFieldsObjectKeys() {
    if (this.visitorInfoFieldBlock) {
      return Object.keys(this.visitorInfoFieldBlock);
    }
  }

  public toggleBlock() {
    this.isBlockOpen = !this.isBlockOpen;
    this.blockStateToggled.emit(this.isBlockOpen);
  }

  private _handleCustomFields(): void {
    Object.keys(this.visitorInfoFieldBlock).forEach((key) => {
      if (this.visitorInfoFieldBlock[key].type === VisitorInfoFieldType.CUSTOM_FIELDS) {
        let hasAtLeastOneVisibleField = this.visitorInfoFieldBlock[key].value.find((customField) => customField.value);
        this.isVisitorInfoFieldBlockVisible = !!hasAtLeastOneVisibleField;
      }
    });
  }
}
